import axios from "../index"

// 接口基础路径
const rootApi = '/api_v2/inspect/task'

/** 生产工单列表 */
export const firstInspectTaskPage = (params) => {
  return axios.get(`${rootApi}/first/page`, {params})
}

// /** 获取详情 */
// export const getInspectTaskDetail = (keyword, inspectModality) => {
//   return axios.get(`${rootApi}/getDetail`, {params: {keyword, inspectModality}})
// }

/** 获取关键词和检验形式获取检验任务列表 */
export const getInspectTaskListByKeyword = (keyword, inspectModality) => {
  return axios.get(`${rootApi}/getListByKeyword`, {params: {keyword, inspectModality}})
}


/** 获取id获取详情 */
export const getInspectTaskDetailById = (taskId) => {
  return axios.get(`${rootApi}/${taskId}/detail`)
}

/** 根据id获取检验单集合 */
export const getInspectSheetListByTaskId = (taskId) => {
  return axios.get(`${rootApi}/${taskId}/inspectSheetList`)
}

/** 获取检验单model */
export const getInspectSheetModelById = (inspectSheetId) => {
  return axios.get(`${rootApi}/${inspectSheetId}/inspectSheetModel`)
}

/** 获取车间流水线检验情况列表 */
export const getAssemblyLineInspectInfoList = (workShopId, inspectModality) => {
  return axios.get(`${rootApi}/getAssemblyLineInspectInfoList`, {params: {workShopId, inspectModality}})
}

/** 检验任务重新检验 */
export const inspectTaskRecheck = (taksId) => {
  return axios.post(`${rootApi}/${taksId}/recheck`)
}

/** 检验方案类型检验 检验提交 */
export const projectInspectSubmit = (params) => {
  return axios.post(`${rootApi}/pattern/project/submit`, params , {dataType: 'json'})
}

/** 提交结果判断 检验提交 */
export const resultInspectSubmit = (params) => {
  return axios.post(`${rootApi}/pattern/result/submit`, params , {dataType: 'json'})
}

/** 获取可选择的签核用户列表 */
export const getSignUserList = () => {
  return axios.get(`${rootApi}/getSignUserList`)
}

/** 获取缺陷总结设置 */
export const getDefectSummarySetting = () => {
  return axios.get(`${rootApi}/defectSummarySetting`)
}
